import { createLucideIcon } from 'lucide-react';
export const LayerGroupIcon = createLucideIcon('layer-group', [
  [
    'path',
    {
      d: 'M11.7188 3.69376L12 3.60001L12.2812 3.69376L19.7812 6.69376L21.5156 7.39688L19.7812 8.10001L16.8516 9.27188L14.8125 10.0922L12.2812 11.1L12 11.1938L11.7188 11.1L9.1875 10.0922L7.14844 9.27188L4.21875 8.10001L2.48438 7.39688L4.21875 6.69376L11.7188 3.69376Z',
      key: '12lxs1',
    },
  ],
  [
    'path',
    {
      d: 'M7.06406 13.2045L2.39999 15.5438L4.13437 16.2469L7.06406 17.4188L9.10312 18.2391L11.6344 19.2469L11.9156 19.3406L12.1969 19.2469L14.7281 18.2391L16.7672 17.4188L19.6969 16.2469L21.4312 15.5438L16.7672 13.2045',
      key: '13vbxm',
    },
  ],
  [
    'path',
    {
      d: 'M7.19999 9.34688L2.39999 11.3438L4.13437 12.0469L7.06406 13.2188L9.10312 14.0391L11.6344 15.0469L11.9156 15.1406L12.1969 15.0469L14.7281 14.0391L16.7672 13.2188L19.6969 12.0469L21.4312 11.3438L16.8 9.34688',
      key: 's8svm2',
    },
  ],
]);
